import React from 'react';

function Bone({width, height, style}) {
    return <div className="skeleton-block" style={{width: width || '100%', height: height || '16px', ...style}} />;
}

function SectionHead({titleWidth = '140px', subWidth = '280px'}) {
    return (
        <div className="resume-skeleton__section-head">
            <Bone width="40px" height="40px" style={{borderRadius: 10, flexShrink: 0}} />
            <div style={{flex: 1, paddingTop: 2}}>
                <Bone width={titleWidth} height="18px" style={{marginBottom: 6}} />
                <Bone width={subWidth} height="14px" />
            </div>
        </div>
    );
}

export default function SkeletonLoader() {
    return (
        <div id="resume-form">
            <div className="resume-skeleton">
                <div className="resume-skeleton__layout">
                    <div className="resume-skeleton__main">
                        {/* Page header */}
                        <div className="resume-skeleton__page-header">
                            <Bone width="220px" height="26px" style={{borderRadius: 20, marginBottom: 14}} />
                            <Bone width="300px" height="32px" style={{marginBottom: 10}} />
                            <Bone width="400px" height="16px" />
                        </div>

                        {/* Section 1: Career Level */}
                        <div className="resume-skeleton__section">
                            <SectionHead titleWidth="130px" subWidth="260px" />
                            <div className="resume-skeleton__tabs">
                                {[1, 2, 3].map(i => (
                                    <Bone key={i} height="60px" style={{flex: 1, borderRadius: 10}} />
                                ))}
                            </div>
                        </div>

                        {/* Section 2: Urgency */}
                        <div className="resume-skeleton__section">
                            <SectionHead titleWidth="90px" subWidth="280px" />
                            <div className="resume-skeleton__tabs">
                                {[1, 2, 3, 4, 5, 6].map(i => (
                                    <Bone key={i} height="60px" style={{flex: 1, borderRadius: 10}} />
                                ))}
                            </div>
                            <Bone height="44px" style={{marginTop: 12, borderRadius: 8}} />
                        </div>

                        {/* Section 3: Services (2-col card grid) */}
                        <div className="resume-skeleton__section">
                            <SectionHead titleWidth="100px" subWidth="280px" />
                            <div className="resume-skeleton__cards-grid">
                                {[1, 2, 3, 4].map(i => (
                                    <div key={i} className="resume-skeleton__card">
                                        <Bone width="20px" height="20px" style={{borderRadius: 5, flexShrink: 0}} />
                                        <Bone style={{flex: 1, height: 14}} />
                                        <Bone width="50px" height="14px" style={{flexShrink: 0}} />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Section 4: Features (2-col card grid) */}
                        <div className="resume-skeleton__section">
                            <SectionHead titleWidth="110px" subWidth="300px" />
                            <div className="resume-skeleton__cards-grid">
                                {[1, 2, 3, 4, 5, 6].map(i => (
                                    <div key={i} className="resume-skeleton__card">
                                        <Bone width="20px" height="20px" style={{borderRadius: 5, flexShrink: 0}} />
                                        <Bone style={{flex: 1, height: 14}} />
                                        <Bone width="50px" height="14px" style={{flexShrink: 0}} />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Total price block */}
                        <div className="resume-skeleton__total">
                            <div className="resume-skeleton__total-price">
                                <Bone width="50px" height="12px" style={{marginBottom: 8}} />
                                <Bone width="150px" height="36px" />
                            </div>
                            <Bone width="190px" height="52px" style={{borderRadius: 10}} />
                        </div>
                    </div>

                    {/* Sidebar — Order Summary */}
                    <div className="resume-skeleton__sidebar">
                        {/* Header */}
                        <div className="resume-skeleton__sidebar-header">
                            <Bone width="120px" height="14px" />
                        </div>

                        {/* Meta block: Career Level + Deadline */}
                        <div className="resume-skeleton__sidebar-meta">
                            {[1, 2].map(i => (
                                <div key={i} className="resume-skeleton__sidebar-meta-item">
                                    <Bone width="32px" height="32px" style={{borderRadius: 8, flexShrink: 0}} />
                                    <div style={{flex: 1, minWidth: 0}}>
                                        <Bone width="70px" height="10px" style={{marginBottom: 6}} />
                                        <Bone width="110px" height="14px" />
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Empty state placeholder */}
                        <div className="resume-skeleton__sidebar-empty">
                            <Bone width="48px" height="48px" style={{borderRadius: 12, margin: '0 auto 10px'}} />
                            <Bone width="140px" height="13px" style={{margin: '0 auto 6px'}} />
                            <Bone width="180px" height="11px" style={{margin: '0 auto'}} />
                        </div>

                        {/* Total card */}
                        <div className="resume-skeleton__sidebar-total">
                            <Bone width="50px" height="11px" style={{marginBottom: 8}} />
                            <Bone width="130px" height="34px" style={{marginBottom: 16}} />
                            <Bone height="44px" style={{borderRadius: 10}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
